const PrevIcon = (props: any) => (
    <svg
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-label="Previous page"
        {...props}
    >
        <path
            d="M15.7049 7.41L14.2949 6L8.29492 12L14.2949 18L15.7049 16.59L11.1249 12L15.7049 7.41Z"
            fill="black"
            fillOpacity={0.38}
        />
    </svg>
);

export default PrevIcon;
